module.exports = __webpack_public_path__ + "static/img/computer.3c254c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/computer.png
// module id = EG9u
// module chunks = 0